import { useLocation } from 'react-router-dom';
import queryString from 'query-string';

// React Router v5 helper to read `prompt` or `q` from the URL query string
export default function usePromptParam() {
  const location = useLocation();
  console.log('[usePromptParam] location.search:', location.search);
  const params = queryString.parse(location.search || '');
  console.log('[usePromptParam] parsed params:', params);
  // Support both 'prompt' and 'q' parameters
  const prompt = params.prompt || params.q || '';
  console.log('[usePromptParam] final prompt:', prompt);
  return typeof prompt === 'string' ? prompt : '';
}



